<template>
  <v-container class="containerAvatarMenu" :class="{ active: isOpen }">
    <v-menu class="containerMenu" v-model="isOpen">
      <template v-slot:activator="{ props }">
        <button class="userAvatarButton pa-4 d-flex ga-2 align-center" v-bind="props">
          <v-avatar color="primary-60" size="36">
            <img v-if="user?.image" :alt="user.name" :src="user.image" class="avatar-image">
            <span v-else class="font-weight-light" style="font-size: 0.90rem;">
              {{ getInitials(user?.name) }}
            </span>
          </v-avatar>
          <div class="d-flex flex-column align-start">
            <v-text class="userFullName">{{ user?.name }}</v-text>
            <v-text class="userLocal">{{ user?.client }}</v-text>
          </div>
          <v-icon :class="{ 'rotate-180': isOpen, 'rotate-0': !isOpen }">mdi-menu-down</v-icon>
        </button>
      </template>
      <v-list class="userAvatarList">
        <v-list-item @click="exitAndRedirect">
          <v-list-item-title class="exitButton d-flex align-center ga-2">
            <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2 18C1.45 18 0.979333 17.8043 0.588 17.413C0.196667 17.0217 0.000666667 16.5507 0 16V2C0 1.45 0.196 0.979333 0.588 0.588C0.98 0.196667 1.45067 0.000666667 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z"
                fill="#BA1A1A" />
            </svg>
            Sair
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue'
import { getInitials } from '@/ai_studio/utils/textFormatter'
import { Get } from "@/ai_studio/http/http.js"
import { useUserStore } from '@/ai_studio/stores/user.js'
import { useAuthStore } from '@/ai_studio/stores/auth.js'
const authStore = useAuthStore();

const userStore = useUserStore()
const user = computed(() => userStore.data)
const isOpen = ref(false)

const exitAndRedirect = async () => {
  const clientUrl = await Get("destroysession")
  authStore.logout();
  if (clientUrl) {
    location.href = clientUrl
  }
}

</script>

<style scoped>
.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.exitButton {
  color: rgb(var(--v-theme-error-40));
  cursor: pointer;
  width: 150px;
  min-width: 112px;
  max-width: 280px;
  padding: 8px 0px;
  border-radius: 4px;
}

.userFullName,
.userLocal {
  font-size: 14px;
  font-family: Roboto;
  font-weight: 400;
}

.userFullName {
  color: rgb(var(--v-theme-neutral-35));
}

.userLocal {
  color: rgb(var(--v-theme-neutral-60));
}

.rotate-0 {
  transform: rotate(0deg);
  transition: transform 0.2s ease-in-out;
}

.rotate-180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease-in-out;
}

.containerAvatarMenu:hover {
  background-color:  rgb(var(--v-theme-neutral-95));
}

.userAvatarList {
  right: -14px;
}

.containerAvatarMenu {
  position: relative;
  border-bottom: 2px solid transparent;
  padding-bottom: 4px;
}

.containerAvatarMenu::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 7px;
  width: 0;
  background-color: rgb(var(--v-theme-primary-60));
  transition: width 0.4s ease-in-out;
}

.containerAvatarMenu.active::after {
  width: 100%;
}

.v-container {
  padding: 0 !important;
}
</style>
